(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("OrderUtil", OrderUtil);

        OrderUtil.$inject = ['$rootScope','DateUtils','$filter','MarketWatch','GlobalValues'];

    function OrderUtil($rootScope,DateUtils,$filter,MarketWatch,GlobalValues) {

    	var service = {
            validateOrderDTOForNull: validateOrderDTOForNull,
            validateSettlementDate:validateSettlementDate,
            validateOptionSettlementDate : validateOptionSettlementDate,
            validateOptionPeriods: validateOptionPeriods,
            validateSession : validateSession,
            validateSessionStatus: validateSessionStatus,
            validateAgreedTAC : validateAgreedTAC,
            validateLimitCheck: validateLimitCheck,
            validateOrderAmount: validateOrderAmount,
            validateLimitExchangeRateHardCheck:validateLimitExchangeRateHardCheck,
            validateSpreadUsed:validateSpreadUsed,
            getEventTypeForShortName : getEventTypeForShortName,
            gettickSizeForGivenInstrument : gettickSizeForGivenInstrument,
            getSettlementDate : getSettlementDate,
            getCloseTimeForInstrumentCode : getCloseTimeForInstrumentCode,
            validateOrderDTOIsNull : validateOrderDTOIsNull,
            validateSessionStatusUsingTokenSeqNo:validateSessionStatusUsingTokenSeqNo,
            validateClearCorpAgreedTAC:validateClearCorpAgreedTAC
    	};
    	return service;

        //validate order DTO
        function validateOrderDTOForNull(orderDTO){
            var isValidOrder = true;
            if (orderDTO.activityIndicator == null || orderDTO.activityIndicator == undefined
                || orderDTO.bankId == null || orderDTO.bankId == undefined
                || orderDTO.bankMemberNumber == null || orderDTO.bankMemberNumber == undefined
                || orderDTO.branchCode == null || orderDTO.branchCode == undefined
                || orderDTO.branchId == null || orderDTO.branchId == undefined
                || orderDTO.buySellIndicator == null || orderDTO.buySellIndicator == undefined
                || orderDTO.customerCode == null || orderDTO.customerCode == undefined
                || orderDTO.customerId == null || orderDTO.customerId == undefined
                || orderDTO.eventType == null || orderDTO.eventType == undefined
                || orderDTO.eventTypeId == null || orderDTO.eventTypeId == undefined
                || orderDTO.expiryTime == null || orderDTO.expiryTime == undefined
                || orderDTO.instrumentCode == null || orderDTO.instrumentCode == undefined
                || orderDTO.instrumentId == null || orderDTO.instrumentId == undefined
                || orderDTO.limitExchangeRate == null || orderDTO.limitExchangeRate == undefined
                || orderDTO.orderAmount == null || orderDTO.orderAmount == undefined
                || orderDTO.retailUserCode == null || orderDTO.retailUserCode == undefined
                || orderDTO.stopExchangeRate == null || orderDTO.stopExchangeRate == undefined
                || orderDTO.timeLimitIndicator == null || orderDTO.timeLimitIndicator == undefined
                || orderDTO.typeOfOrder == null || orderDTO.typeOfOrder == undefined
                || orderDTO.userEntityOwnerId == null || orderDTO.userEntityOwnerId == undefined
                || orderDTO.userId == null || orderDTO.userId == undefined

                || orderDTO.settlementIFSCCode == null ||orderDTO.settlementIFSCCode == undefined
                || orderDTO.deliveryMode == null || orderDTO.deliveryMode == undefined || orderDTO.noOfTrades == null || orderDTO.noOfTrades == undefined
                || orderDTO.tradeTotalPrice == null || orderDTO.tradeTotalPrice == undefined || orderDTO.sourceAppId == null
                || orderDTO.sourceAppId == undefined){
                isValidOrder = false;
                var orderDTOObj = angular.copy(angular.toJson(orderDTO));
                console.log(orderDTOObj);
            }
            //if given instrument is forward and then validate tradeSettlementDate, exposureType, exposureSubType
            else if(orderDTO.instrumentCode == 'Forward' && (orderDTO.tradeSettlementDate == null || orderDTO.tradeSettlementDate == undefined)){
                isValidOrder = false;
                var orderDTOObj = angular.copy(angular.toJson(orderDTO));
                console.log(orderDTOObj);
            }

            return isValidOrder;
        }

        function validateOptionSettlementDate(instrumentCode ,isOptionPeriod ,  settlementDate, dateFromOrTo){
            // do validateion only if forwards and option period is true else skip validation
        	if(instrumentCode != 'Forward' ||  (instrumentCode == 'Forward' && isOptionPeriod != true ) ){
         	   return {
                isValid: true,
                errorString : errorString
            }
            }
            var isValid = true;
            var errorString = "";
            var selectedDateText = "Selected Forward Option Period " + dateFromOrTo + " date ";
           // var errorText = "errorInOptionPeriod" + dateFromOrTo;
            var serverSettlemntDate = DateUtils.convertLocalDateToServer(settlementDate);

            var holidayList = _.filter($rootScope.holidayListAfterBusinessDate, function(s){return s.indexOf(serverSettlemntDate)!==-1;});


            if(settlementDate == null || settlementDate == undefined ){
            	isValid = false;
            	errorString = "Forward Option Period " + dateFromOrTo + " date is mandatory..!";
            	//MessageBox.openMessageBox("Alert", "Option Period " + dateFromOrTo + " date is mandatory", "Ok", errorText);

            }else if(holidayList!=null && holidayList!=undefined && holidayList.length>0){

            	isValid = false;
                errorString = selectedDateText +"is a Holiday. For Holiday List, kindly refer to Holiday View screen in General Reports menu...!";
               //MessageBox.openMessageBox("Alert", , "Ok", errorText);

            }else{
            	 //validate sett. date should not be greater than the maximum renor/value defined in the limits
            	if($rootScope.maxForwardTenorDate !=null && $rootScope.maxForwardTenorDate != undefined && moment(settlementDate).isAfter($rootScope.maxForwardTenorDate, 'day')){

            		isValid = false;
                    errorString = selectedDateText +"is greater than the" + " maximum tenor/value date defined by the Relationship Bank. Please refer the Limit Tab for more info on maximum tenor/value date allowed...!";
                    // MessageBox.openMessageBox("Alert", , "Ok", errorText);
                }else if( moment(settlementDate).isBefore( moment($rootScope.spotNextDate), 'day') || moment(settlementDate).isAfter( moment($rootScope.maxTenorDate), 'day')){
                    //validate sett. date should not be less than spot next date. and should not be greater than last tenor value
                	isValid = false;
                	errorString = selectedDateText +"should be between Spot Next Date and maximum tenor date...!";
                    //MessageBox.openMessageBox("Alert", , "Ok", errorText);

                }
            }
            return {
                isValid: isValid,
                errorString : errorString
            }
        }

        function validateOptionPeriods(instrumentCode, isOptionPeriod, from,to){
            // do validateion only if forwards and option period is true else skip validation
        	if(instrumentCode != 'Forward' ||  (instrumentCode == 'Forward' && isOptionPeriod != true ) ){
          	  return {
                isValid: true,
                errorString : errorString
            }
        }
        	//validate sett. date should be fall in holiday
            var isValid = true;
            var errorString = "";
            var errorShortString = "";
            //var errorText = "errorInOptionPeriodFRomAndTo";
                //validate sett. date should not be spot date. since, spot mkt watch is in separate section.
                //and sett. date should not be less than current business date.
                if( moment(from).isSame(moment(to), 'day') ){
                    isValid = false;
                    errorString = "Forward Option Period Start date and End date cannot be same...!";
                    errorShortString = "Start date and End date cannot be same";
                   // MessageBox.openMessageBox("Alert", "Option Period From and To cannot be same...!", "Ok", errorText);

                }else if(moment(from).isAfter(moment(to), 'day')){
                	isValid = false;
                	errorString = "Forward Option Period Start date cannot be greater than End date...!";
                    errorShortString = "Start date cannot be greater than End date"
                    //MessageBox.openMessageBox("Alert", "Option Period From is greater than To...!", "Ok", errorText);
                }
                else if(moment(to).diff(moment(from) ,'day') > $rootScope.maximumOptionPeriodDuration){
                	isValid = false;
                	errorString = "Forward Option Period date range cannot be more than "+ $rootScope.maximumOptionPeriodDuration+" days...!";
                    errorShortString = "Option Period date range cannot be more than "+ $rootScope.maximumOptionPeriodDuration+" days";
                    //MessageBox.openMessageBox("Alert", , "Ok", errorText);
                }

            return {
                isValid:isValid,
                errorString: errorString,
                errorShortString : errorShortString
            }
        }
        function validateSettlementDate(instrumentCode ,isOptionPeriod ,  settlementDate, dateFromOrTo){
            // do validateion only if forwards and option period is true else skip validation
        	if(instrumentCode != 'Forward' ||  (instrumentCode == 'Forward' && isOptionPeriod != false ) ){
         	   return {
                isValid: true,
                errorString : errorString
            }
            }
            var isValid = true;
            var errorString = "";
            var selectedDateText = "Selected " + dateFromOrTo + " date ";
            var serverSettlemntDate = DateUtils.convertLocalDateToServer(settlementDate);

            var holidayList = _.filter($rootScope.holidayListAfterBusinessDate, function(s){return s.indexOf(serverSettlemntDate)!==-1;});


            if(settlementDate == null || settlementDate == undefined ){
            	isValid = false;
            	errorString =  dateFromOrTo + " date is mandatory..!";

            }else if(holidayList!=null && holidayList!=undefined && holidayList.length>0){

                isValid = false;
                errorString = selectedDateText +"is a Holiday. For Holiday List, kindly refer to Holiday View screen in General Reports menu...!";


            }else{
            	 if( moment(settlementDate).isBefore( moment($rootScope.spotNextDate), 'day') || moment(settlementDate).isAfter( moment($rootScope.maxTenorDate), 'day')){
                     //validate sett. date should not be less than spot next date. and should not be greater than last tenor value
                	isValid = false;
                	errorString = selectedDateText +"should be between Spot Next Date and maximum tenor date...!";

                 }
            }
            return {
                isValid: isValid,
                errorString : errorString
            }
        }

        function validateSession(instrumentCode, priceCondtion,tokenSequenceNo){
        	if(!validateSessionStatus(instrumentCode)&&$rootScope.currencyCode == 'USD'){
        		return false;
        	}
            else{
                if(!validateSessionStatusUsingTokenSeqNo(instrumentCode,tokenSequenceNo)){
                    return false;
                }
            }

            if(!validateAgreedTAC()){
                return false;
            }
        	return true;
        }

        // validate session status
        function validateSessionStatus(instrumentCode){
        	var status = "";
        	var errorString = "";
        	 if(instrumentCode == 'SPOT'){
        	 	status = $rootScope.retailSpotMarketSession.sessionTimingsDTO.status;
        	 }else if(instrumentCode == 'CASH'){
        	 	status = $rootScope.cashMarketSession.sessionTimingsDTO.status;
        	 }else if(instrumentCode == 'TOM'){
        	 	status = $rootScope.tomMarketSession.sessionTimingsDTO.status;
        	 }else if(instrumentCode == 'Forward'){
                 status = $rootScope.forwardMarketSession.sessionTimingsDTO.status;
             }
        	
        	if(status!='OPEN'){
        		errorString = "Session is closed for " + instrumentCode + " market...!"
        		return {
                    isValid:false,
                    errorString :  errorString
                }
        	}

        	 return {
                isValid:true,
                errorString :  ""
            }
        }


        // validate session status
        function validateSessionStatusUsingTokenSeqNo(tokenSequenceNo,instrumentCode){
        	var status = "";
        	var errorString = "";

           status = $rootScope.marketSessionMap[tokenSequenceNo].sessionTimingsDTO.status;
           var instrumentDetails = $rootScope.marketSessionMap[tokenSequenceNo];
        	// if(instrumentCode == 'SPOT'){
        	// 	status = $rootScope.retailSpotMarketSession.sessionTimingsDTO.status;
        	// }else if(instrumentCode == 'CASH'){
        	// 	status = $rootScope.cashMarketSession.sessionTimingsDTO.status;
        	// }else if(instrumentCode == 'TOM'){
        	// 	status = $rootScope.tomMarketSession.sessionTimingsDTO.status;
        	// }else if(instrumentCode == 'Forward'){
            //     status = $rootScope.forwardMarketSession.sessionTimingsDTO.status;
            // }
        if (!instrumentDetails.instrumentApplicable) {
            errorString = "Unavailable for " + instrumentCode + " market...!"
                return {
                    isValid:false,
                    errorString :  errorString
                }
        }else if(status!='OPEN'){
        		errorString = "Session is closed for " + instrumentCode + " market...!"
        		return {
                    isValid:false,
                    errorString :  errorString
                }
        }else if (instrumentDetails.isSettlementDateHoliday) {
                    errorString = " Holiday for " + instrumentCode + " market...!"
                return {
                    isValid:false,
                    errorString :  errorString
                }
        }
            return {
                isValid:true,
                errorString :  ""
            }
        }


        function validateAgreedTAC(tradingBank){
            var isValid = true;
            var errorString = "";
            if($rootScope.account!=null && $rootScope.account.organisation.organisationType.shortName=='CUSTOMER'){
                if($rootScope.agreedTACList!=null && $rootScope.agreedTACList!=undefined && $rootScope.agreedTACList.length>0){
                    //validate clearcorp TAC
                    if($rootScope.agreedTACList[0].isAgreed){
                        //validate selected trading bank TAC
                        if(tradingBank!=null && tradingBank!=undefined){
                            var agreedTACListForBank = _.filter(angular.copy($rootScope.agreedTACList), {'providerId': tradingBank.id});
                            if(agreedTACListForBank!=null && agreedTACListForBank!=undefined && agreedTACListForBank.length>0){
                                if(!agreedTACListForBank[0].isAgreed){
                                   errorString = "This activity cannot be completed. Kindly accept the revised Clearcorp/Relationship Bank Terms and Conditions by accessing from the “Settings menu >> Terms and Conditions view” menu in order to proceed with Order activity.";
                                    isValid = false;
                                }
                            }else{
                                errorString = "This activity cannot be completed. Kindly accept the revised Clearcorp/Relationship Bank Terms and Conditions by accessing from the “Settings menu >> Terms and Conditions view” menu in order to proceed with Order activity.";
                                isValid= false;
                            }
                        }else{
                            errorString = "Trading bank should be selected to place order...!";
                            isValid= false;
                        }
                    }else{
                        errorString = "This activity cannot be completed. Kindly accept the revised Clearcorp/Relationship Bank Terms and Conditions by accessing from the “Settings menu >> Terms and Conditions view” menu in order to proceed with Order activity.";
                        isValid =  false;
                    }

                }
            }
            return {
                isValid:isValid,
                errorString :  errorString
            }

        }

        function validateClearCorpAgreedTAC(){
            var isValid = true;
            var errorString = "";
            if($rootScope.account!=null && $rootScope.account.organisation.organisationType.shortName=='CUSTOMER'){
                if($rootScope.agreedTACList!=null && $rootScope.agreedTACList!=undefined && $rootScope.agreedTACList.length>0){
                    //validate clearcorp TAC
                    if(! $rootScope.agreedTACList[0].isAgreed  ){
                        errorString = "Kindly accept the revised Clearcorp Terms and Conditions by accessing from the “Settings menu >> Terms and Conditions view” ";
                        isValid =  false;
                    }
                }
            }
            return {
                isValid:isValid,
                errorString :  errorString
            }

        }

        function validateLimitCheck(oldOrderAmount, activityIndicator, orderAmount, instrumentCode, buySellFlag, priceCondition, tradeSettlementDate){
            var isValid = true;
            var errorObject = { message: "" };
        	// if($rootScope.limitNotDefined){
    		// 	errorString = "Trading limits are not defined. Order entry not possible...!";
    		// 	isValid =  false;
        	// }
            //valdiate max tenor date
            if(instrumentCode=='Forward'){
                if(moment(tradeSettlementDate).isAfter($rootScope.maxForwardTenorDate, 'day')){
                    //vm.errorString = "Settlement date is beyond the given limit maximum tenor date. Cannot place order...!";
                    errorObject.message = "Order entry not possible. Settlement date selected is greater than the" +
                    " maximum tenor/value date defined by the Relationship Bank. Please refer the Limit Tab for more info on maximum tenor/value date allowed.";

                    isValid = false;
                }
            }
        	if(buySellFlag=='SELL'){
        		if(!validateSellLimit(oldOrderAmount, activityIndicator, instrumentCode, orderAmount, priceCondition)){
        			errorObject.message = "Sell trading limit breached. Order entry not possible...!";
        			isValid = false;
        		}
        	}else if(buySellFlag=='BUYY'){
        		if(!validateBuyLimit(oldOrderAmount, activityIndicator, instrumentCode, orderAmount, priceCondition)){
        			errorObject.message = "Buy trading limit breached. Order entry not possible...!";
        			isValid = false;
        		}
        	}else if(buySellFlag=='SELLBUY'){
        		if(priceCondition=='MRKT'){
            		if(instrumentCode=='SPOT'){
            			if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.retailSpotBuyLimitForMkt, $rootScope.retailSpotSellLimitForMkt,errorObject)){
            				isValid = false;
            			}
            		}else if(instrumentCode=='CASH'){
            			if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.cashBuyLimitForMkt, $rootScope.cashSellLimitForMkt,errorObject)){
            				isValid = false;
            			}
            		}else if(instrumentCode=='TOM'){
            			if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.tomBuyLimitForMkt, $rootScope.tomSellLimitForMkt,errorObject)){
            				isValid = false;
            			}
            		}else if(instrumentCode=='Forward'){
                        if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.forwardBuyLimitWithCF, $rootScope.forwardSellLimitWithCF,errorObject)){
                            isValid = false;
                        }
                    }
        		}else{
            		if(instrumentCode=='SPOT'){
            			if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.retailSpotBuyLimit, $rootScope.retailSpotSellLimit,errorObject)){
            				isValid = false;
            			}
            		}else if(instrumentCode=='CASH'){
            			if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.cashBuyLimit, $rootScope.cashSellLimit,errorObject)){
            				isValid = false;
            			}
            		}else if(instrumentCode=='TOM'){
            			if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.tomBuyLimit, $rootScope.tomSellLimit,errorObject)){
            				isValid = false;
            			}
            		}else if(instrumentCode=='Forward'){
                        if(!validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, $rootScope.forwardBuyLimitWithCF, $rootScope.forwardSellLimitWithCF,errorObject)){
                            isValid = false;
                        }
                    }
        		}
        	}
        	return {
                isValid: isValid,
                errorString : errorObject.message
            }
        }

        /*
		 * validate sell limit
		 */
        function validateSellLimit(oldOrderAmount, activityIndicator, instrumentCode, orderAmount, priceCondition){
        	if(priceCondition=='MRKT'){
        		if(activityIndicator=='PLAC'){
            		if(instrumentCode=='SPOT'){
                		if(orderAmount > $rootScope.retailSpotSellLimitForMkt){
                			return false;
                		}
            		}else if(instrumentCode=='CASH'){
                		if(orderAmount > $rootScope.cashSellLimitForMkt){
                			return false;
                		}
            		}else if(instrumentCode=='TOM'){
                		if(orderAmount > $rootScope.tomSellLimitForMkt){
                			return false;
                		}
            		}else if(instrumentCode=='Forward'){
                        if(orderAmount > $rootScope.forwardSellLimitWithCF){
                            return false;
                        }
                    }
            	}else if(activityIndicator=='MDFY'){
            		if(instrumentCode=='SPOT'){
                		if(orderAmount > $rootScope.retailSpotSellLimitForMkt + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='CASH'){
                		if(orderAmount > $rootScope.cashSellLimitForMkt + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='TOM'){
                		if(orderAmount > $rootScope.tomSellLimitForMkt + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='Forward'){
                        if(orderAmount > $rootScope.forwardSellLimitWithCF + oldOrderAmount){
                            return false;
                        }
                    }
            	}
        	}else{
        		if(activityIndicator=='PLAC'){
            		if(instrumentCode=='SPOT'){
                		if(orderAmount > $rootScope.retailSpotSellLimit){
                			return false;
                		}
            		}else if(instrumentCode=='CASH'){
                		if(orderAmount > $rootScope.cashSellLimit){
                			return false;
                		}
            		}else if(instrumentCode=='TOM'){
                		if(orderAmount > $rootScope.tomSellLimit){
                			return false;
                		}
            		}else if(instrumentCode=='Forward'){
                        if(orderAmount > $rootScope.forwardSellLimitWithCF){
                            return false;
                        }
                    }
            	}else if(activityIndicator=='MDFY'){
            		if(instrumentCode=='SPOT'){
                		if(orderAmount > $rootScope.retailSpotSellLimit + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='CASH'){
                		if(orderAmount > $rootScope.cashSellLimit + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='TOM'){
                		if(orderAmount > $rootScope.tomSellLimit + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='Forward'){
                        if(orderAmount > $rootScope.forwardSellLimitWithCF + oldOrderAmount){
                            return false;
                        }
                    }
            	}
        	}
        	return true;
        }

        /*
		 * validate buy limit
		 */
        function validateBuyLimit(oldOrderAmount, activityIndicator, instrumentCode, orderAmount, priceCondition){
        	if(priceCondition=='MRKT'){
        		if(activityIndicator=='PLAC'){
            		if(instrumentCode=='SPOT'){
                		if(orderAmount > $rootScope.retailSpotBuyLimitForMkt){
                			return false;
                		}
            		}else if(instrumentCode=='CASH'){
                		if(orderAmount > $rootScope.cashBuyLimitForMkt){
                			return false;
                		}
            		}else if(instrumentCode=='TOM'){
                		if(orderAmount > $rootScope.tomBuyLimitForMkt){
                			return false;
                		}
            		}else if(instrumentCode=='Forward'){
                        if(orderAmount > $rootScope.forwardBuyLimitWithCF){
                            return false;
                        }
                    }
            	}else if(activityIndicator=='MDFY'){
            		if(instrumentCode=='SPOT'){
                		if(orderAmount > $rootScope.retailSpotBuyLimitForMkt + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='CASH'){
                		if(orderAmount > $rootScope.cashBuyLimitForMkt + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='TOM'){
                		if(orderAmount > $rootScope.tomBuyLimitForMkt + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='Forward'){
                        if(orderAmount > $rootScope.forwardBuyLimitWithCF + oldOrderAmount){
                            return false;
                        }
                    }
            	}
        	}else{
        		if(activityIndicator=='PLAC'){
            		if(instrumentCode=='SPOT'){
                		if(orderAmount > $rootScope.retailSpotBuyLimit){
                			return false;
                		}
            		}else if(instrumentCode=='CASH'){
                		if(orderAmount > $rootScope.cashBuyLimit){
                			return false;
                		}
            		}else if(instrumentCode=='TOM'){
                		if(orderAmount > $rootScope.tomBuyLimit){
                			return false;
                		}
            		}else if(instrumentCode=='Forward'){
                        if(orderAmount > $rootScope.forwardBuyLimitWithCF){
                            return false;
                        }
                    }
            	}else if(activityIndicator=='MDFY'){
            		if(instrumentCode=='SPOT'){
                		if(orderAmount > $rootScope.retailSpotBuyLimit + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='CASH'){
                		if(orderAmount > $rootScope.cashBuyLimit + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='TOM'){
                		if(orderAmount > $rootScope.tomBuyLimit + oldOrderAmount){
                			return false;
                		}
            		}else if(instrumentCode=='Forward'){
                        if(orderAmount > $rootScope.forwardBuyLimitWithCF + oldOrderAmount){
                            return false;
                        }
                    }
            	}
        	}

            return true;
        }

         /*
		 * validate limits for sell and buy order
		 */
         function validateLimitForeSellAndBuyOrder(instrumentCode, orderAmount, buyLimit, sellLimit,errorObject){
            var isValid = true;
        	if($rootScope.limitType == 'GLOBALGROSS' && orderAmount > (buyLimit/2)){
				errorObject.message = "Global gross limit breached. Order entry is not possible...!";
				isValid = false;
			}
    		if(orderAmount > buyLimit){
    			errorObject.message = "Buy trading limit breached. Order entry is not possible...!";
    			isValid = false;
    		}else if(orderAmount > sellLimit){
    			errorObject.message = "Sell trading limit breached. Order entry is not possible...!";
    			isValid = false;
    		}
    		return isValid;
        }


        // validate order amount
        function validateOrderAmount(orderAmount){
        	// orderAmount = orderAmount.replace(/,/g, '');
            var isValid = true;
            var errorString = "";
            var errorShortString = "";
            var configSettings = $rootScope.configurationSettingsForOrder;
            var userPreference = angular.copy($rootScope.userPreferenceForOrder);
            var noOfDecimalsForAmount = angular.copy($rootScope.noOfDecimalsForAmountForOrder);
            var transactionParametersSettings = angular.copy($rootScope.transactionParametersSettingsForOrder);
            var currencyPair =  angular.copy($rootScope.currencyPairForOrder);

        	if(Math.round(parseFloat(orderAmount) * 100) / Math.round(parseFloat(1) * 100) ==0){
        		errorString = 'Order value should be greater than zero...! ';
                errorShortString = errorString;
        		isValid = false;
        	}else if(Number(orderAmount) < 0){
        		errorString = 'Order value should be positive...!';
                errorShortString = 'Order Quantity cannot be negative;';
        		isValid = false;
            }else{

                var transactionParamterMinimumOrderValue = GlobalValues.getTransactionParameterValue(currencyPair.id, "MinimumOrderValue");
                var transactionParamterMaximumOrderValue = GlobalValues.getTransactionParameterValue(currencyPair.id, "MaximumOrderValueHardCheck");

                // Get the currency specific user preference limit for hard check
                var userMaxHardCheck = null;
                var userMaxSoftCheck = null;
                if ($rootScope.currencyWiseUserPreferenceSettings) {
                    var pref = $rootScope.currencyWiseUserPreferenceSettings[currencyPair.id];
                    if (pref) {
                        userMaxHardCheck = pref.configs[1];
                        userMaxSoftCheck = pref.configs[2];
                    }
                }

                if(transactionParamterMinimumOrderValue!=null && transactionParamterMaximumOrderValue!=null){
                    if(Number(orderAmount) < Number(transactionParamterMinimumOrderValue)){
                        errorString = 'Order value should be greater than or equal to CCIL minimum order value ('+currencyPair.baseCurrency.code + ' ' + $filter('number')(transactionParamterMinimumOrderValue, noOfDecimalsForAmount) + '). Order entry restricted..!';
                        errorShortString = 'Hard check should be greater than ('+currencyPair.baseCurrency.code + ' ' + $filter('number')(transactionParamterMinimumOrderValue, noOfDecimalsForAmount) + ')';
                        isValid = false;
                    }else if(Number(orderAmount) > Number(transactionParamterMaximumOrderValue)){
                        errorString = 'Breach of CCIL maximum order value </br> <span class="hardcheck-value">('+currencyPair.baseCurrency.code + ' ' + $filter('number')(transactionParamterMaximumOrderValue, noOfDecimalsForAmount) + ')</span> hard check.</br> Order entry restricted..!';
                        errorShortString = 'Hard check ( '+currencyPair.baseCurrency.code + ' ' + $filter('number')(transactionParamterMaximumOrderValue, noOfDecimalsForAmount) + ') Breached';
                        isValid = false;
                    }else if(userMaxHardCheck != null && Number(orderAmount) > Number(userMaxHardCheck)){
                        errorString = 'Breach of user level maximum order value </br> <span class="hardcheck-value">('+currencyPair.baseCurrency.code + ' ' + $filter('number')(userMaxHardCheck, noOfDecimalsForAmount) + ')</span> hard check.</br> Order entry restricted..!';
                        errorShortString = 'Hard check User Level ( '+currencyPair.baseCurrency.code + ' ' + $filter('number')(userMaxHardCheck, noOfDecimalsForAmount) + ') Breached';
                        isValid = false;
                    }else if(((Math.round(parseFloat(orderAmount) * 10000)) % (Math.round(parseFloat(configSettings.orderLotSize) * 10000)))!=0){
                        errorString = "Order value should be in multiples of lot size " + $filter('number')(configSettings.orderLotSize, noOfDecimalsForAmount) + "...!";
                        errorShortString = 'Order value should be in multiples of lot size ('+ currencyPair.baseCurrency.code + ' ' + $filter('number')(configSettings.orderLotSize, noOfDecimalsForAmount);
                        isValid = false;
                    }
                }

            }

        	return {
                isValid: isValid,
                errorString : errorString,
                errorShortString : errorShortString
            }
        }



        function validateLimitExchangeRateHardCheck(buySellFlag, priceCondtion, selectedBankSpread, instrumentCode, activityIndicator, orderAmount, oldOrderAmount,limitExchangeRate,limitExchangeRateInSpot,buyLimitExchangeRate,buyLimitExchangeRateInSpot,sellLimitExchangeRate,sellLimitExchangeRateInSpot,currencyPair,currencyPairId,defaultInstrumentTokenSequenceNo){
        	var ordertickSize = "";


            var transactionParametersSettings = angular.copy($rootScope.transactionParametersSettingsForOrder);

            var currencyPairValue =  angular.copy($rootScope.currencyPairForOrder);

             var configSettings = $rootScope.configurationSettingsForOrder;

             var alertInstrumentCode = instrumentCode;

            var allowedOrderPriceDeviationFromMarketPriceInPercentage = 0;
            var userAllowedOrderPriceDeviationFromMarketPriceInPercentage = 0;

            var transactionParamterValue = GlobalValues.getTransactionParameterValue(currencyPairValue.id, "AllowedOrderPriceDeviationFromMarketPriceInPercentage");

            if(transactionParamterValue != null){
                allowedOrderPriceDeviationFromMarketPriceInPercentage = transactionParamterValue;
            }else{
                allowedOrderPriceDeviationFromMarketPriceInPercentage = configSettings.allowedOrderPriceDeviationFromMarketPriceInPercentage;
            }

            // Get user level deviation from currency wise settings
            if ($rootScope.currencyWiseUserPreferenceSettings) {
                var pref = $rootScope.currencyWiseUserPreferenceSettings[currencyPairValue.id];
                if (pref) {
                   userAllowedOrderPriceDeviationFromMarketPriceInPercentage = pref.configs[3];
                }
            }

            if(currencyPairValue.code==='USDINR'){
              ordertickSize =  gettickSizeForGivenInstrument(instrumentCode);
              alertInstrumentCode = 'Spot';
            }
            else{

                var instrumentDetails = $rootScope.marketWatchMap[currencyPairId].instruments[getIndexBasedOnInstrument(instrumentCode)];

               ordertickSize = gettickSizeForGivenInstrument(instrumentCode,'',instrumentDetails.tokenSequenceNo);
            }
        	var ltp = 0
            var userPreference = angular.copy($rootScope.userPreferenceForOrder);
            var errorObject = { message: "" ,shortMessage:""};
            var isValid = true;
        	if(buySellFlag!='SELLBUY'){
            	ltp = getLtpValue(currencyPairValue,defaultInstrumentTokenSequenceNo);
            	if(!validateLimitExchangeRate(buySellFlag, activityIndicator, priceCondtion, limitExchangeRate, limitExchangeRateInSpot, ordertickSize, ltp, allowedOrderPriceDeviationFromMarketPriceInPercentage, userAllowedOrderPriceDeviationFromMarketPriceInPercentage,errorObject,currencyPair,defaultInstrumentTokenSequenceNo,alertInstrumentCode)){
            		isValid = false;
            	}
        	}else if(buySellFlag=='SELLBUY'){
            	var ltp = getLtpValue(currencyPairValue,defaultInstrumentTokenSequenceNo);
            	if(!validateLimitExchangeRate('BUYY', activityIndicator, priceCondtion, buyLimitExchangeRate, buyLimitExchangeRateInSpot, ordertickSize, ltp, allowedOrderPriceDeviationFromMarketPriceInPercentage, userAllowedOrderPriceDeviationFromMarketPriceInPercentage,errorObject,currencyPair,defaultInstrumentTokenSequenceNo,alertInstrumentCode)){
            		// return false;
            	}
            	if(!validateLimitExchangeRate('SELL', activityIndicator, priceCondtion, sellLimitExchangeRate, sellLimitExchangeRateInSpot, ordertickSize, ltp, allowedOrderPriceDeviationFromMarketPriceInPercentage, userAllowedOrderPriceDeviationFromMarketPriceInPercentage,errorObject,currencyPair,defaultInstrumentTokenSequenceNo,alertInstrumentCode)){
            		// return false;
            	}
            	if(errorObject.message!='' && errorObject.message!=null && errorObject.message!=undefined){
            		isValid = false;
            	}
        	}
        	return {
                isValid: isValid,
                errorString : errorObject.message,
                errorShortString : errorObject.shortMessage
            }
        }
        // get tick size
       function gettickSizeForGivenInstrument(instrumentCode,baseCurrency,tokenSequenceNo){
        if(baseCurrency==='USD'){
        	if(instrumentCode=='SPOT'){
        		return $rootScope.tickSize.usd.spot;
        	}else if(instrumentCode=='CASH'){
        		return $rootScope.tickSize.usd.cash;
        	}else if(instrumentCode=='TOM'){
        		return $rootScope.tickSize.usd.tom;
        	}else if(instrumentCode=='Forward'){
                return $rootScope.tickSize.usd.forward;
            }
        }
         else{

            var tikSizeValues = $rootScope.tickSize.other[tokenSequenceNo];

            if(instrumentCode=='SPOT'){
        		return tikSizeValues.spot;
        	}else if(instrumentCode=='CASH'){
        		return tikSizeValues.cash;
        	}else if(instrumentCode=='TOM'){
        		return tikSizeValues.tom;
        	}

         }
    }
    function gettickSizeForGivenInstrument(instrumentCode){
        if(instrumentCode=='SPOT'){
            return $rootScope.tickSize.usd.spot;
        }else if(instrumentCode=='CASH'){
            return $rootScope.tickSize.usd.cash;
        }else if(instrumentCode=='TOM'){
            return $rootScope.tickSize.usd.tom;
        }else if(instrumentCode=='Forward'){
            return $rootScope.tickSize.usd.forward;
        }
    }

    // get ltp for given instrument and buy sell flag
    // function getLtpValue(currencyPair,tokenSeqNo){

    //     if(currencyPair=='USDINR'){
    //     if($rootScope.ibSpotMarketDepth!=null && $rootScope.ibSpotMarketDepth!=undefined){
    //         if($rootScope.ibSpotMarketDepth.ltp!=null && $rootScope.ibSpotMarketDepth.ltp!=undefined && $rootScope.ibSpotMarketDepth.ltp>0){
    //             return $rootScope.ibSpotMarketDepth.ltp;
    //         }else{
    //             return $rootScope.previousDayClosingPriceForIbSpot;
    //         }
    //     }else{
    //         return $rootScope.previousDayClosingPriceForIbSpot;
    //     }
    // }
    //       else{
    //         $rootScope.dailyClosingPriceFCY[tokenSeqNo].previouseDayClosingPrice;
    //     }
    // }

  function getLtpValue(currencyPair,tokenSequenceNo) {
            if(currencyPair.code=='USDINR'){
            if ($rootScope.ibSpotMarketDepth != null && $rootScope.ibSpotMarketDepth != undefined) {
                if ($rootScope.ibSpotMarketDepth.ltp != null && $rootScope.ibSpotMarketDepth.ltp != undefined && $rootScope.ibSpotMarketDepth.ltp > 0) {
                    return $rootScope.ibSpotMarketDepth.ltp;
                } else {
                    return $rootScope.previousDayClosingPriceForIbSpot;
                }
            } else {
                return $rootScope.previousDayClosingPriceForIbSpot;
            }
        }
        else{

             if ($rootScope.tickerPriceFCY[tokenSequenceNo] != null && $rootScope.tickerPriceFCY[tokenSequenceNo] != undefined) {
                if ($rootScope.tickerPriceFCY[tokenSequenceNo].ltp != null && $rootScope.tickerPriceFCY[tokenSequenceNo].ltp != undefined && $rootScope.tickerPriceFCY[tokenSequenceNo].ltp > 0) {
                    return $rootScope.tickerPriceFCY[tokenSequenceNo].ltp;
                } else {
                    return $rootScope.dailyClosingPriceFCY[tokenSequenceNo].previouseDayClosingPrice;
                }
            } else {

            return $rootScope.dailyClosingPriceFCY[tokenSequenceNo].previouseDayClosingPrice;
            }
        }
        }


    function validateLimitExchangeRate(buySellFlag, activityIndicator, priceCondition, limitExchangeRate,limitExchangeRateInSpot, ordertickSize, ltp, allowedOrderPriceDeviationInPercent, allowedOrderPriceDeviationInPercentUserSettings,errorObject,currencyPair,defaultInstrumentTokenSequenceNo,alertInstrumentCode){
        ltp = Number(ltp);

        if(priceCondition!='MRKT'){
            if(Number(limitExchangeRate)<0){
                if(buySellFlag=='BUYY'){
                    errorObject.message = 'Buy limit price should be positive...!';
                    errorObject.shortMessage = 'Buy limit price cannot be negative';
                }else{
                    errorObject.message = 'Sell limit price should be positive...!';
                    errorObject.shortMessage = 'Sell limit price cannot be negative';
                }
                return false;
            }
        }

        if((priceCondition!='MRKT' && Number(limitExchangeRate)==0) || (priceCondition=='MRKT' && activityIndicator=='MDFY' && Number(limitExchangeRate)==0)){
            if(buySellFlag=='BUYY'){
                errorObject.message = 'Buy limit price should be greater than zero...!';
            }else{
                errorObject.message = 'Sell limit price should be greater than zero...!';
            }
            errorObject.shortMessage = errorObject.message;
            return false;
        }
        var tickSizeRemainder = (Math.round(parseFloat(limitExchangeRate)*10000)) % (Math.round(parseFloat(ordertickSize)*10000));
        if(tickSizeRemainder!=0 && priceCondition!='MRKT'){
            if(buySellFlag=='BUYY'){
                errorObject.message = 'Buy limit price should be in multiples of tick size ' + Number(ordertickSize) + '...!';
            }else{
                errorObject.message = 'Sell limit price should be in multiples of tick size ' + Number(ordertickSize) + '...!';
            }
            errorObject.shortMessage = 'Price should be in multiples of tick size '+ Number(ordertickSize);
            return false;
        }

       // if(currencyPair=='USDINR'){
        if(!validateLimitExchangeRateRange(limitExchangeRateInSpot, allowedOrderPriceDeviationInPercentUserSettings, ltp, ordertickSize, priceCondition, buySellFlag, 'user',errorObject,currencyPair,defaultInstrumentTokenSequenceNo,alertInstrumentCode)){
            return false;
        }
    //}

        if(!validateLimitExchangeRateRange(limitExchangeRateInSpot, allowedOrderPriceDeviationInPercent, ltp, ordertickSize, priceCondition, buySellFlag, 'clearcorp',errorObject,currencyPair,defaultInstrumentTokenSequenceNo,alertInstrumentCode)){
            return false;
        }

        return true;
    }

    function validateLimitExchangeRateRange(limitExchangeRateInSpot, allowedOrderPriceDeviationInPercent, ltp, ordertickSize, priceCondition, buySellFlag, level,errorObject,currencyPair,defaultInstrumentTokenSequenceNo,alertInstrumentCode){
        var isValid = true;

        if(currencyPair == 'USDINR'){
        var higherCutOffPrice = $rootScope.previousDayClosingPriceForIbSpot + ($rootScope.previousDayClosingPriceForIbSpot * Number(allowedOrderPriceDeviationInPercent/100));
        var lowerCutOffPrice = $rootScope.previousDayClosingPriceForIbSpot - ($rootScope.previousDayClosingPriceForIbSpot * Number(allowedOrderPriceDeviationInPercent/100));
        }else{
                    var previousDayClosingPrice = $rootScope.dailyClosingPriceFCY[defaultInstrumentTokenSequenceNo].previouseDayClosingPrice
                    var higherCutOffPrice = previousDayClosingPrice + ($rootScope.previousDayClosingPriceForIbSpot * Number(allowedOrderPriceDeviationInPercent/100));
                    var lowerCutOffPrice =previousDayClosingPrice - ($rootScope.previousDayClosingPriceForIbSpot * Number(allowedOrderPriceDeviationInPercent/100));

        }
        var noOfDecimalsForRate = $rootScope.noOfDecimalsForRateForOrder;
        if(currencyPair == 'USDINR'){
        if(ltp>0 && ltp!=undefined && ltp!=null){
            higherCutOffPrice = ltp + (ltp * Number(allowedOrderPriceDeviationInPercent/100));
            lowerCutOffPrice = ltp - (ltp * Number(allowedOrderPriceDeviationInPercent/100));
        }}else{
            higherCutOffPrice = ltp + (ltp * Number(allowedOrderPriceDeviationInPercent/100));
            lowerCutOffPrice = ltp - (ltp * Number(allowedOrderPriceDeviationInPercent/100));
        }
        higherCutOffPrice = (Math.round(parseFloat(higherCutOffPrice)*10000)/10000);
        lowerCutOffPrice = (Math.round(parseFloat(lowerCutOffPrice)*10000)/10000)
        var higherCutOffPriceRemainder = (Math.round(parseFloat(((Math.round(parseFloat(higherCutOffPrice)*10000)) % (Math.round(parseFloat(ordertickSize)*10000))/10000))*10000)/10000);
        higherCutOffPrice = (Math.round(parseFloat(higherCutOffPrice)*10000)/10000) - (Math.round(parseFloat(higherCutOffPriceRemainder)*10000)/10000);

            var lowerCutOffPriceRemainder = (Math.round(parseFloat(((Math.round(parseFloat(lowerCutOffPrice)*10000)) % (Math.round(parseFloat(ordertickSize)*10000))/10000))*10000)/10000);
        if(lowerCutOffPriceRemainder!=0){
            lowerCutOffPrice = (Math.round(parseFloat(lowerCutOffPrice)*10000)/10000) - (Math.round(parseFloat(lowerCutOffPriceRemainder)*10000)/10000) + (Math.round(parseFloat(ordertickSize)*10000)/10000);
        }else{
            lowerCutOffPrice = (Math.round(parseFloat(lowerCutOffPrice)*10000)/10000);
        }

            if(priceCondition!='MRKT' && (Math.round(parseFloat(limitExchangeRateInSpot)*10000) < Math.round(parseFloat(lowerCutOffPrice)*10000) ||  Math.round(parseFloat(limitExchangeRateInSpot)*10000) > Math.round(parseFloat(higherCutOffPrice)*10000))){
            if(buySellFlag=='BUYY'){
                if(level=='user'){
                    errorObject.message = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached User level limit price Hard check.</br> BUY Equivalent Spot Price should be between </br>' +"<span class='hardcheck-value'>" +  $filter('number')(lowerCutOffPrice, noOfDecimalsForRate) +"</span> "+  ' and ' +"<span class='hardcheck-value'>" +  $filter('number')(higherCutOffPrice, noOfDecimalsForRate)+"</span> ";
                    errorObject.shortMessage = 'Equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price User level Hard check breached. Price should be between '+$filter('number')(lowerCutOffPrice, noOfDecimalsForRate) +  ' and ' +  $filter('number')(higherCutOffPrice, noOfDecimalsForRate);
                }else{
                    errorObject.message = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached CCIL limit price Hard check.</br> BUY Equivalent Spot Price should be between </br> ' +"<span class='hardcheck-value'>"+ $filter('number')(lowerCutOffPrice, noOfDecimalsForRate)+"</span> " +  ' and ' + "<span class='hardcheck-value'>"+$filter('number')(higherCutOffPrice, noOfDecimalsForRate) +"</span> ";
                    errorObject.shortMessage = 'Equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price CCIL Hard check breached. Price should be between '+$filter('number')(lowerCutOffPrice, noOfDecimalsForRate) +  ' and ' +  $filter('number')(higherCutOffPrice, noOfDecimalsForRate);

                }
            }else{
                if(level=='user'){
                    if(errorObject.message!=''){
                        errorObject.message = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached User level limit price Hard check.</br> BUY and SELL Equivalent Spot Price should be between </br>' +"<span class='hardcheck-value'>"+ $filter('number')(lowerCutOffPrice, noOfDecimalsForRate)+"</span> " +  ' and ' +"<span class='hardcheck-value'>"+ $filter('number')(higherCutOffPrice, noOfDecimalsForRate) +"</span> ";
                    }else{
                        errorObject.message = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached User level limit price Hard check.</br> SELL Equivalent Spot Price should be between </br>' + "<span class='hardcheck-value'>"+$filter('number')(lowerCutOffPrice, noOfDecimalsForRate) +"</span> "+  ' and ' +"<span class='hardcheck-value'>"+ $filter('number')(higherCutOffPrice, noOfDecimalsForRate)+"</span> ";
                        errorObject.shortMessage = 'Equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price User level Hard check breached. Price should be between '+$filter('number')(lowerCutOffPrice, noOfDecimalsForRate) +  ' and ' +  $filter('number')(higherCutOffPrice, noOfDecimalsForRate);
                    }
                }else{
                    if(errorObject.message!=''){
                        errorObject.message = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached CCIL limit price Hard check.</br> BUY and SELL Equivalent Spot Price should be between </br>' +"<span class='hardcheck-value'>"+ $filter('number')(lowerCutOffPrice, noOfDecimalsForRate)+"</span> " +  ' and ' +"<span class='hardcheck-value'>"+ $filter('number')(higherCutOffPrice, noOfDecimalsForRate)+"</span> ";
                    }else{
                        errorObject.message = 'Order entry not possible as equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price </br> has breached CCIL limit price Hard check.</br> SELL Equivalent Spot Price should be between </br>' +"<span class='hardcheck-value'>"+ $filter('number')(lowerCutOffPrice, noOfDecimalsForRate)+"</span> " +  ' and ' + "<span class='hardcheck-value'>"+$filter('number')(higherCutOffPrice, noOfDecimalsForRate)+"</span> ";
                        errorObject.shortMessage = 'Equivalent '+$filter('capitalizeFirst')(alertInstrumentCode)+' price CCIL Hard check breached. Price should be between '+$filter('number')(lowerCutOffPrice, noOfDecimalsForRate) +  ' and ' +  $filter('number')(higherCutOffPrice, noOfDecimalsForRate);

                    }
                }
            }
            isValid = false;
        }
        return isValid;
    }

    function validateSpreadUsed(selectedBankSpread, instrumentCode, buySellFlag){
        var errorString ='';
        var isValid = true;
        if(instrumentCode!='SPOT'){
            var tickSize = gettickSizeForGivenInstrument(instrumentCode);
            var settlementDate = getSettlementDate(instrumentCode, buySellFlag);
            var spreadUsed = MarketWatch.getSpreadForTenorAndSettlementDate(selectedBankSpread, instrumentCode, buySellFlag,
                DateUtils.convertLocalDateToServer(settlementDate), $rootScope.retailSpotMarketSession.settlementDate,
                tickSize);
            //var spreadUsed = getSpreadUsed(selectedBankSpread, buySellFlag, instrumentCode);
            if((spreadUsed==null || spreadUsed==undefined || spreadUsed=='') && spreadUsed!=0){
                if(buySellFlag=='BUYY'){
                    if(instrumentCode=='CASH'){
                        errorString = 'CASH/SPOT bid spread is not given by the bank. Order entry not possible...!';
                    }else if(instrumentCode=='TOM'){
                        errorString = 'TOM/SPOT bid spread is not given by the bank. Order entry not possible...!';
                    }else if(instrumentCode=='Forward'){
                        errorString = 'Order entry not possible as FORWARD offer spread for the selected settlement date ('+  $filter('date')(settlementDate,'dd-MMM-yyyy') +') is not provided by your Relationship bank.';
                    }
                }else if(buySellFlag=='SELL'){
                    if(instrumentCode=='CASH'){
                        errorString = 'CASH/SPOT offer spread is not given by the bank. Order entry not possible...!';
                    }else if(instrumentCode=='TOM'){
                        errorString = 'TOM/SPOT offer spread is not given by the bank. Order entry not possible...!';
                    }else if(instrumentCode=='Forward'){
                        errorString = 'Order entry not possible as FORWARD bid spread for the selected settlement date ('+  $filter('date')(settlementDate,'dd-MMM-yyyy') +') is not provided by your Relationship bank.';
                    }
                }
                isValid = false;
            }
        }
        return {
            isValid:isValid,
            errorString:errorString
        }
    }

    /* get settlemnt date based on the order type, instrument and tenor name*/
    function getSettlementDate( instrumentCode, orderType){
        var settlementDate = angular.copy($rootScope.tradeSettlementDateFororder);
        if( $rootScope.tenor !=null){
            console.log('instrumentCode - ' + instrumentCode + ' orderType - ' + orderType + ' tenorName - ' + $rootScope.tenor.tenorName);
        }
        if(instrumentCode == 'Forward' && $rootScope.tenor !=null && $rootScope.tenor != undefined && $rootScope.tenor.tenorName == 'Option Period'){
            if( orderType =="SELL" ){
                settlementDate = angular.copy($rootScope.tradeSettlementDateFrom);
            }else
            {
                settlementDate = angular.copy($rootScope.tradeSettlementDateFororder);
            }
        }
        return settlementDate;
    }

    function getEventTypeForShortName(eventTypeShortName){
        var eventType = {};
        angular.forEach($rootScope.eventTypes, function(value){
            if(value.shortName==eventTypeShortName){
                eventType = value;
            }
        })
        return eventType;
    }
    function getCloseTimeForInstrumentCode(instrument){
        if(instrument=='SPOT'){
            return $rootScope.retailSpotMarketSession.sessionTimingsDTO.closeTime;
        }else if(instrument=='CASH'){
            return $rootScope.cashMarketSession.sessionTimingsDTO.closeTime;
        }else if(instrument=='TOM'){
            return $rootScope.tomMarketSession.sessionTimingsDTO.closeTime;
        }else if(instrument=='Forward'){
            return $rootScope.forwardMarketSession.sessionTimingsDTO.closeTime;
        }
    }

    function validateOrderDTOIsNull (orderDTO){
        //validate sett. date should be fall in holiday
        var isValid = true;
        var errorString = "";
        var errorShortString = "";

        // do validateion only if forwards and option period is true else skip validation
        if(orderDTO.instrumentCode != 'Forward' ||  (orderDTO.instrumentCode == 'Forward' && orderDTO.isOptionPeriod != true ) ){
            return {
                isValid: true,
                errorString : errorString
            }
        }

            if(orderDTO.activityIndicator == null || orderDTO.activityIndicator == undefined ){
                errorString = 'Activity Indicator should be NULL ...!';
                errorShortString = 'Activity Indicator  cannot be NULL;';
        		isValid = false;

            }else if( orderDTO.bankId == null || orderDTO.bankId == undefined){
                errorString = 'Bank Id should be NULL ...!';
                errorShortString = 'Bank Id  cannot be NULL;';
        		isValid = false;

            }else if( orderDTO.bankMemberNumber == null || orderDTO.bankMemberNumber == undefined){
                errorString = 'Bank Member Number should be NULL ...!';
                errorShortString = 'Bank Member Number  cannot be NULL;';
        		isValid = false;
              }else if( orderDTO.branchCode == null || orderDTO.branchCode == undefined){
                errorString = 'Branch Code should be NULL ...!';
                errorShortString = 'Branch Code  cannot be NULL;';
        		isValid = false;
               }else if( orderDTO.branchId == null || orderDTO.branchId == undefined ){
                errorString = 'Branch Id should be NULL ...!';
                errorShortString = 'Branch Id  cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.buySellIndicator == null || orderDTO.buySellIndicator == undefined){
                errorString = 'Buy Sell Indicator should be NULL ...!';
                errorShortString = 'Buy Sell Indicator  cannot be NULL;';
        		isValid = false;
                }else if(orderDTO.customerCode == null || orderDTO.customerCode == undefined){
                errorString = 'Customer Code should be NULL ...!';
                errorShortString = 'Customer Code  cannot be NULL;';
        		isValid = false;
               }else if( orderDTO.customerId == null || orderDTO.customerId == undefined){
                errorString = 'Customer Id should be NULL ...!';
                errorShortString = 'Customer Id  cannot be NULL;';
        		isValid = false;
                }else if(orderDTO.eventType == null || orderDTO.eventType == undefined){
                errorString = 'Event Type should be NULL ...!';
                errorShortString = 'Event Type  cannot be NULL;';
        		isValid = false;
               }else if( orderDTO.eventTypeId == null || orderDTO.eventTypeId == undefined){
                errorString = 'Event Type Id should be NULL ...!';
                errorShortString = 'Event Type Id  cannot be NULL;';
        		isValid = false;
               }else if( orderDTO.expiryTime == null || orderDTO.expiryTime == undefined){
                errorString = 'Expiry Time should be NULL ...!';
                errorShortString = 'Expiry Time  cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.instrumentCode == null || orderDTO.instrumentCode == undefined){
                errorString = 'Instrument Code should be NULL ...!';
                errorShortString = 'Instrument Code  cannot be NULL;';
        		isValid = false;
               }else if( orderDTO.instrumentId == null || orderDTO.instrumentId == undefined){
                errorString = 'Instrument Id should be NULL ...!';
                errorShortString = 'Instrument Id  cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.limitExchangeRate == null || orderDTO.limitExchangeRate == undefined){
                errorString = 'Limit Exchange Rate should be NULL ...!';
                errorShortString = 'Limit Exchange Rate cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.orderAmount == null || orderDTO.orderAmount == undefined){
                errorString = 'Order Amount should be NULL ...!';
                errorShortString = 'Order Amount cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.retailUserCode == null || orderDTO.retailUserCode == undefined){
                errorString = 'Retail User Code should be NULL ...!';
                errorShortString = 'Retail User Code cannot be NULL;';
        		isValid = false;
                }else if(orderDTO.stopExchangeRate == null || orderDTO.stopExchangeRate == undefined){
                errorString = 'Stop Exchange Rate should be NULL ...!';
                errorShortString = 'Stop Exchange Rate cannot be NULL;';
        		isValid = false;
                }else if(orderDTO.timeLimitIndicator == null || orderDTO.timeLimitIndicator == undefined){
                errorString = 'Time Limit Indicator should be NULL ...!';
                errorShortString = 'Time Limit Indicator  cannot be NULL;';
        		isValid = false;
               }else if( orderDTO.typeOfOrder == null || orderDTO.typeOfOrder == undefined){
                errorString = 'Type Of Orderr should be NULL ...!';
                errorShortString = 'Type Of Order cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.userEntityOwnerId == null || orderDTO.userEntityOwnerId == undefined){
                errorString = 'User Entity Owner Id should be NULL ...!';
                errorShortString = 'User Entity Owner Id  cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.userId == null || orderDTO.userId == undefined ){
                errorString = 'User Id should be NULL ...!';
                errorShortString = 'User Id Indicator  cannot be NULL;';
        		isValid = false;

            }else if( orderDTO.settlementIFSCCode == null ||orderDTO.settlementIFSCCode == undefined){
                errorString = 'Settlement IFSC Code should be NULL ...!';
                errorShortString = 'Settlement IFSC Code  cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.deliveryMode == null || orderDTO.deliveryMode == undefined ){
                errorString = 'Delivery Mode should be NULL ...!';
                errorShortString = 'Delivery Mode  cannot be NULL;';
        		isValid = false;
                }else if(orderDTO.noOfTrades == null || orderDTO.noOfTrades == undefined ){
                errorString = 'No Of Trades should be NULL ...!';
                errorShortString = 'No Of Trades  cannot be NULL;';
        		isValid = false;
            } else if (orderDTO.tradeTotalPrice == null || orderDTO.tradeTotalPrice == undefined) {
                errorString = 'Trade Total Price should be NULL ...!';
                errorShortString = 'Trade Total Price  cannot be NULL;';
        		isValid = false;
                }else if( orderDTO.sourceAppId == null|| orderDTO.sourceAppId == undefined){
                errorString = 'Source App Id should be NULL ...!';
                errorShortString = 'Source App Id  cannot be NULL;';
        		isValid = false;
            }
            return {
                isValid: isValid,
                errorString : errorString,
                errorShortString : errorShortString
            }
        }

           function getIndexBasedOnInstrument(instrumentCode){

if (instrumentCode === 'SPOT') {
    return 0;
} else if (instrumentCode === 'TOM') {
   return 1;
} else if (instrumentCode === 'CASH') {
  return 2;
}

        }


    }
})();
